import { Component, Prop, h } from '@stencil/core';

@Component({
  tag: 'schema-slot',
  styleUrl: 'schemaSlot.css',
  shadow: true,
})
export class SchemaSlot {
  @Prop() schema: slotSchema[] = [];

  render() {
    return (
      <div class="action-panel">
        {this.schema.map(val => (
          <div class="val-button" > 
          {/* key={val.name} */}
            <slot name={val.name}>
              <button class={`btn ${val.type || 'default'}`}>
                {val.label}
              </button>
            </slot>
          </div>
        ))}
      </div>
    );
  }
}